import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplaySkeleton } from 'app/agriculture/components/StatDisplay/StatDisplaySkeleton';

export function DiagnosticDisplaySkeleton() {
    return (
        <ContentBox.Section heading="Device Stats" disableDivider>
            <SimpleGrid className="DiagnosticDisplay" columns={3}>
                <StatDisplaySkeleton label="Error codes" />
                <StatDisplaySkeleton label="Available memory" />
                <StatDisplaySkeleton label="Firmware version" />
                <StatDisplaySkeleton label="Hardware version" />
                <StatDisplaySkeleton label="Supporting binding and modes" />
                <StatDisplaySkeleton label="Uptime" />
            </SimpleGrid>
        </ContentBox.Section>
    );
}
